var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('FullscreenModal',{attrs:{"show-close-button":false}},[_c('spinner-loader')],1):_vm._e(),_c('button',{staticClass:"button",on:{"click":function($event){return _vm.initPicker()}}},[_c('img',{attrs:{"src":require('../../assets/g-drive-logo.svg'),"alt":"logo gdrive"}}),_c('span',[_vm._v("Drive")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }